import { useTranslation } from '@mint-lib/i18n';
import { typographyVariants } from '@mint-lib/tw-components';

import type { ContentBlock } from '../../types.js';
import { RelatedChip } from './RelatedChip.jsx';

type Props = {
  relatedBlocks: ContentBlock[];
  scrollToItem: (element: string) => void;
};

const RelatedChipsBlock = ({ relatedBlocks, scrollToItem }: Props) => {
  const { t } = useTranslation('@mint-lib/ai-chat');
  const config = {
    table: t('Related table'),
    graph: t('Related chart'),
  };
  const types = new Set(relatedBlocks.map(({ type }) => type));
  const label = config[[...types][0]]; // Only one related item

  return (
    <div className="flex flex-col gap-2">
      <p className={typographyVariants({ variant: 'h6' })}>{label}</p>
      <div className="flex flex-row gap-1">
        {relatedBlocks.map((block) => (
          <RelatedChip
            key={`${block.type}-${block.varName}`}
            subtype={block.subtype}
            text={block.varName}
            onClick={() => scrollToItem(block.id)}
          />
        ))}
      </div>
    </div>
  );
};

export { RelatedChipsBlock };
